import React, { useState, useEffect } from "react";

import "./stylesPoker.css";
import HandDetails from "./HandDetails";

import { Pagination, Table, message } from "antd";
import { LeftOutlined } from "@ant-design/icons";
import createPrivateAdminPanelInstance from "../../../../api/PrivateAdminPanelInstance";
import { API_ROUTES } from "../../../../api/ApiRoutes";
import dayjs from "dayjs";
import RebetLoader from "../../../CommonComponents/RebetLoader/RebetLoader";

function HandTable({ userData, setActiveSection, handData }) {
  const token = JSON.parse(localStorage.getItem("token"));
  const PrivateAdminPanelInstance = createPrivateAdminPanelInstance(
    token?.IdToken
  );
  const [selectedHand, setSelectedHand] = useState(null);
  const [pagination, setPagination] = useState({
    current_page: 1,
    total_pages: 0,
    has_next_page: false,
    has_previous_page: false,
  });

  const columns = [
    {
      title: "Hand ID",
      dataIndex: "hand_id",
      key: "hand_id",
      width: 150,
    },
    {
      title: "Round Start Time",
      dataIndex: "round_start_time",
      key: "round_start_time",
      width: 150,
    },
    {
      title: "Round End Time",
      dataIndex: "round_end_time",
      key: "round_end_time",
      width: 150,
    },
    {
      title: "Status",
      dataIndex: "status",
      key: "status",
      width: 150,
    },
    {
      title: "Bet Amount",
      dataIndex: "bet_amount",
      key: "bet_amount",
      width: 150,
      render: (text) => {
        return (
          <p style={{ margin: 0 }}>
            {Intl.NumberFormat("en-US", {
              style: "currency",
              currency: "USD",
            }).format(text)}
          </p>
        );
      },
    },
    {
      title: "Payout",
      dataIndex: "payout",
      key: "payout",
      width: 150,
      render: (text) => {
        return (
          <p style={{ margin: 0 }}>
            {Intl.NumberFormat("en-US", {
              style: "currency",
              currency: "USD",
            }).format(text)}
          </p>
        );
      },
    },
  ];

  const [handsData, setHandsData] = useState([]);
  const [open, setOpen] = useState(false);
  const [isApiRunning, setIsApiRunning] = useState(false);

  const getUserPokerHands = async (page = 1) => {
    setIsApiRunning(true);

    const params = {
      user_id: userData?.user_id,
      game_id: handData?.game_id,
      page: page,
    };

    try {
      const pokerHandsResponse = await PrivateAdminPanelInstance?.post(
        API_ROUTES?.GET_USER_POKER_GAME_HANDS,
        params
      );

      const data = pokerHandsResponse?.data?.data?.data;
      const pagination = pokerHandsResponse?.data?.data?.pagination;
      const formattedData = (Array.isArray(data) ? data : []).map((game) => {
        return {
          ...game,
          hand_number: game.hand_id.split(":")[1],
          round_start_time: dayjs(game.round_start_time).format("HH:mm"),
          round_end_time: dayjs(game.round_end_time).format("HH:mm"),
        };
      });
      setHandsData(formattedData);
      setPagination({
        current_page: pagination?.current_page || 1,
        total_pages: pagination?.total_pages || 1,
        total_hands: pagination?.total_hands || formattedData.length,
        per_page: pagination?.per_page || formattedData.length || 10,
        has_next_page: pagination?.has_next || false,
        has_previous_page: pagination?.has_previous || false,
      });
      if (!Array.isArray(data) || data.length === 0) {
        message.open({
          type: "info",
          content: "No hands found for this game.",
          key: "poker-hands-empty",
        });
      }
    } catch (error) {
      console.log("error fetching poker hands", error);
      message.error("Failed to fetch poker hands.");
      setIsApiRunning(false);
    } finally {
      setIsApiRunning(false);
    }
  };
  const handlePaginationChange = (page) => {
    getUserPokerHands(page);
  };
  useEffect(() => {
    getUserPokerHands();
  }, [handData]);

  return (
    <div className="poker-bets-container">
      <HandDetails
        open={open}
        setOpen={setOpen}
        gameId={handData?.game_id}
        selectedHand={selectedHand}
        userId={userData?.user_id}
      />
      <div className="poker-bets-header"></div>
      <div className="poker-bets-table-container">
        <div className="head-controls poker-bets-table-header-container">
          <div
            className="back-button-container"
            onClick={() => setActiveSection("Poker Table")}
          >
            <LeftOutlined style={{ color: "white" }} />
          </div>

          <div className="header-text-container">
            <p className="header-text">{userData?.username}'s Game Hands</p>
          </div>
        </div>

        <div className="">
          {isApiRunning ? (
            <RebetLoader height={"100px"} width={"100px"} />
          ) : (
            <div className="poker-bets-table hand-table">
              <Table
                dataSource={handsData}
                columns={columns}
                rowKey={(record) => record.hand_id}
                scroll={{ y: 500 }}
                pagination={false}
                locale={{ emptyText: "No hands found for this game." }}
                onRow={(record) => ({
                  onClick: () => {
                    setSelectedHand(record);
                    setOpen(true);
                  },
                  className: "poker-bets-table-row",
                })}
              />
              <div className="sports-bets-pagination-container">
              <Pagination
                  current={pagination.current_page}
                  total={pagination.total_hands}
                  pageSize={pagination.per_page}
                  hasNext={pagination.has_next_page}
                  hasPrevious={pagination.has_previous_page}
                  showSizeChanger={false}
                  onChange={(page) => {
                    if (
                      page === pagination.current_page - 1 ||
                      page === pagination.current_page + 1
                    ) {
                      handlePaginationChange(page);
                    }
                  }}
                  itemRender={(page, type, originalElement) => {
                    if (type === "page") {
                      return (
                        <a
                          rel="nofollow"
                          disabled={page > pagination.current_page + 1}
                          className={`${
                            page > pagination.current_page + 1 ? "disabled" : ""
                          }`}
                        >
                          {page}
                        </a>
                      );
                    }
                    return originalElement;
                  }}
                />
              </div>
            </div>
          )}
        </div>
      </div>
    </div>
  );
}

export default HandTable;
